export default __webpack_public_path__ + "static/media/artist-img8.a199ba44.jpg";